<template>
  <v-row justify="center">
    <v-btn
      class="pt-0 pb-0"
      width="210px"
      style="background-color: #EAEAEA; cursor:default;margin-top:20px;margin-bottom:20px;"
      bottom
      dark
      height="170px"
    >
      <v-card-text class="pt-0 pb-0">
        <p class="black--text mb-0 text-left pt-0 pb-0">
          <b>안전한 크롬 브라우저로</b>
        </p>
        <p class="black--text mb-0 text-left">
          <b>사용하세요.</b>
        </p>

        <div align="center">
          <v-btn
            depressed
            small
            color="amber lighten-1"
            class="mt-3 mb-0 black--text font-weight-black"
            v-on:click="browserCrome"
            aling="left"
            width="175px"
          >크롬 다운로드</v-btn>
        </div>
        <p class="black--text mb-0 mt-3 text-left caption">보안 이슈로 정품인증서비스는</p>
        <p class="black--text mb-0 mt-0 text-left caption">크롬에서만 사용 가능합니다.</p>
      </v-card-text>
    </v-btn>
  </v-row>
</template>

<script>
export default {
  methods: {
    browserCrome: function() {
      window.open("https://www.google.com/intl/ko/chrome/", "crome", "_blank");
    },
    browserIE: function() {
      window.open(
        "https://support.microsoft.com/ko-kr/help/17621/internet-explorer-downloads",
        "ie",
        "_blank"
      );
    }
  }
};
</script>
